import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from '@mui/material';
import { customerAuth } from './customerAuth';

const CustomerLogin = ({ onLogin, initialMessage }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success] = useState(initialMessage || '');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await customerAuth.login(email, password);
            onLogin();
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
            <Card sx={{ width: 420, mx: 2 }}>
                <Box sx={{ backgroundColor: '#0b355d', color: 'white', p: 3, textAlign: 'center' }}>
                    <Typography variant="h5">Pacific Landscape Supply</Typography>
                    <Typography variant="body2" sx={{ mt: 1, opacity: 0.8 }}>Customer Order Portal</Typography>
                </Box>
                <CardContent sx={{ p: 3 }}>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

                    <form onSubmit={handleLogin}>
                        <TextField fullWidth label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} margin="normal" required />
                        <TextField fullWidth label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} margin="normal" required />
                        <Button fullWidth variant="contained" type="submit" disabled={loading} sx={{ mt: 2, backgroundColor: '#0b355d' }}>
                            {loading ? 'Signing in...' : 'Sign In'}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
};

export default CustomerLogin;
